import { Component, HostBinding, Input } from '@angular/core';


@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  @HostBinding('style.--current-progress')
  @Input() public currentProgress: string | undefined;

  @HostBinding('style.--background-color')
  @Input() public backgroundColor: string = '';

  @HostBinding('style.--foreground-color')
  @Input() public foregroundColor: string = '';

  @HostBinding('style.--size')
  @Input() public size: string = '';

}
